'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const HomeHeroDeferredIsland = dynamic(
  () => import('./HomeHeroDeferredIsland').then((mod) => mod.HomeHeroDeferredIsland),
  { ssr: false },
);

export function HomeHeroIdleEnhancementsLoader({ trustFallback }: { trustFallback: string }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const reveal = () => setReady(true);
    window.addEventListener('pointerdown', reveal, { once: true, passive: true });
    window.addEventListener('keydown', reveal, { once: true });

    return () => {
      window.removeEventListener('pointerdown', reveal);
      window.removeEventListener('keydown', reveal);
    };
  }, []);

  return ready ? <HomeHeroDeferredIsland trustFallback={trustFallback} /> : null;
}
